<template>
  <layout-guest>
    <v-container class="py-10" style="position: inherit">
      <v-row>
        <v-col cols="12" sm="5" md="5">
          <img
            :src="
              isError
                ? basePath + 'assets/images/login/error.svg'
                : basePath + 'assets/images/login/succes@2x.png'
            "
            class="header-brand-img-login2 centrado-img"
            alt="logo"
          />
        </v-col>

        <v-col cols="12" sm="7" md="7">
          <v-col cols="12" sm="12" md="12">
            <p class="source-sans-pro-ligh">
              {{ title }}
            </p>

            <small class="source-sans-pro-ligh2">
              {{ message }}
            </small>
          </v-col>
          <v-container v-if="!isError" style="position: inherit">
            <v-form v-model="valid">
              <v-row>
                <v-col cols="12" sm="12" md="6" lg="5">
                  <label>{{ $t("users.newPassword") }}</label>
                  <v-text-field
                    dense
                    outlined
                    v-model="newPassword"
                    :color="entityConfig.primaryColor"
                    :type="show2 ? 'text' : 'password'"
                    :append-icon="show2 ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="show2 = !show2"
                    :rules="newPasswordRules"
                    autocomplete="false"
                    maxlength="30"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="5">
                  <label>{{ $t("users.confirmPassword") }}</label>
                  <v-text-field
                    dense
                    outlined
                    v-model="confirmPassword"
                    :color="entityConfig.primaryColor"
                    :type="show3 ? 'text' : 'password'"
                    :append-icon="show3 ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="show3 = !show3"
                    :rules="confirmPasswordRules"
                    autocomplete="false"
                    maxlength="30"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="pb-5">
                <v-col cols="12" sm="12" md="12" lg="10">
                  <v-btn
                    depressed
                    :color="entityConfig.primaryColor"
                    :style="`color: ${entityConfig.secondaryColor}`"
                    class="float-end v-btn-width-default"
                    :disabled="!valid"
                    @click="changePassword()"
                  >
                    {{ $t("supplierData.save") }}
                  </v-btn>
                </v-col>
                <v-col></v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-col>
      </v-row>

      <overlay :visible="spinner" :opacity="1"></overlay>
    </v-container>
  </layout-guest>
</template>

<style scoped lang="scss">
@import "../supplier/supplier.style.scss";
</style>

<script>
import passwordValidator from "password-validator";
import LayoutGuest from "../../components/layouts/layout-guest.vue";
import Api from "../../Services/index";
import Overlay from "../../components/layouts/overlay.vue";

export default {
  name: "App",
  data() {
    return {
      show1: false,
      show2: false,
      show3: false,
      valid: false,
      basePath: process.env.VUE_APP_CONTEXT_PATH,
      newPassword: "",
      confirmPassword: "",
      title: "Oh no, algo ha ido mal",
      isError: false,
      entityConfig: {},
      message:"",
      spinner: false,
      urlLogin: "/",
      newPasswordRules: [
        (v) => v?.length >= 12 || "12 caracteres Minimo",
        (v) => v?.length <= 30 || "30 caracteres Maximo",
        (v) => {
          let schema = new passwordValidator();
          schema.has().uppercase();
          return (
            schema.validate(v) ||
            "Debe contener al menos 1 caracter en mayuscula"
          );
        },
        (v) => {
          let schema = new passwordValidator();
          schema.has().lowercase();
          return (
            schema.validate(v) ||
            "Debe contener al menos 1 caracter en minuscula"
          );
        },
        (v) => {
          let schema = new passwordValidator();
          schema.has().digits();
          return schema.validate(v) || "Debe contener carateres numericos";
        },
        (v) => {
          let schema = new passwordValidator();
          schema.has().symbols();
          return (
            schema.validate(v) ||
            "Debe contener caracteres especiales: <>+|&!*%?:. =-"
          );
        },
        (v) =>
          !/[^\w<>+|&!*%?:. =-]/.test(v) ||
          "Caracteres especiales permitidos: <>+|&!*%?:. =-",
        (v) =>
          !/(.)\1{2}/.test(v) ||
          "No se permiten mas de 2 caracteres consecutivos",
      ],
      confirmPasswordRules: [
        () => this.newAndConfirmPassAreEqual || "Las contraseñas no coinciden",
      ],
    };
  },
  components: {
    Overlay,
    "layout-guest": LayoutGuest,
  },
  mounted() {
    setTimeout(() => {
      this.entityConfig = this.$store.state.entityConfig.config;
    }, 1000);
    let userId = this.$route.query.id;
    let token = this.$route.query.token;

    if (userId && token) {
      this.sendConfirmation(userId, token);
    } else {
      this.isError = true;
      this.spinner = false;
      return;
    }
  },
  computed: {
    newAndConfirmPassAreEqual: function () {
      return (
        this.newPassword !== "" && this.newPassword === this.confirmPassword
      );
    },
  },
  methods: {
    sendConfirmation(userId, token) {
      this.spinner = true;
      delete Api.defaults.headers.common["Authorization"];
      delete Api.defaults.headers["Authorization"];
      Api.patch(`/usuarios/${userId}/confirmar-email?token=${token}`, {
      }).then(() => {
          this.isError = false;
          this.title = "¡Todo Listo!";
          this.message =
            "Tu usuario ya esta activado, asigna un password para poder iniciar sesión";
        })
        .catch((error) => {
          if(error.response.data.code == 739){
            this.message = this.$t("login.tokenExpiradoConfirmar")
          }else{
            this.message =  this.$t("login.losientoError")
          }
          this.$showError(this, error.response.data);
          this.isError = true;
        })
        .finally(() => {
          this.spinner = false;
        });
    },
    changePassword() {
      this.spinner = true;
      const passwords = {
        token: this.$route.query.token,
        newPassword: this.newPassword,
      };
      Api.patch(`/usuarios/credenciales`, passwords)
        .then(() => {
          this.$toast.success("Password Asignado, ya puedes iniciar sesión");
          this.$router.push({
            name: "Login",
          });
        })
        .catch((error) => {
          this.$showError(this, error.response.data);
        })
        .finally(() => {
          this.spinner = false;
        });
    },
  },
};
</script>
